//アカウント設定ページ /newEdit
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import define from './define';
import users from './store/user'
import {Link, browserHistory} from 'react-router'
import cryptojs from 'crypto-js';
import firebase from 'firebase'

import {
  onLogin, logout, updateProfile, statusIdReupload,
  setTempNewEmail,getTempNewEmail,updateEmail, getCurrentEmail, deleteUserScores
} from './firebase'
import request from 'request-promise';
import htmlspecialchars from 'htmlspecialchars';
import './css/newEdit.css';
import './css/toast_custom.css';

import Profileimage from './profileImage'
import Photoupdate from './photoupdate'
import Toast from './components/toast'
import Permission from './components/permission'


export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      edit_displayName:"",
      edit_realName: "",
      edit_email:"",
      bio:"",
      //deleteStart:false,
      error_message:'',
      max_length: 200,
      current_bio_length:0,
      user:{},
      changephoto:false,
      send_trustdock:true,

    };

    this.loginCheck()
  }

  handleChangeRealName = (e) => {
    let name = e.target.value
    this.setState({edit_realName: name});
  }

  handleChangeName = (e) => {
    let name = e.target.value
    this.setState({edit_displayName: name});
  }

  handleChangeEmail = (e) => {
    let email = e.target.value
    this.setState({edit_email: email});
  }

  handleChangeBio = (e) => {
    let bio = e.target.value
    if(this.checkBioLength(bio)) {
      this.setState({bio: bio});
    }
  }

  checkBioLength = (bio) => {
    if(bio.length <= this.state.max_length) {
      //console.log(bio.length)
      this.setState({current_bio_length:bio.length})
      return true
    }
  }

  showTextLengh = () => {
    const {
      current_bio_length,
      max_length
    } = this.state
    let showLength = current_bio_length ? current_bio_length : 0
    //TODO style属性 -> cssに定義 color指定
    return (
      <div className="" style={{'display':'inline-block'}}>
        <span>字数：</span>
        <span>{showLength}</span>
        <span>/</span>
        <span>{max_length}</span>
      </div>
    )
  }

  // 保存ボタン
  changeUserInfo = (e) => {
    if (200 >= this.state.bio.length) {
      if (users.getMyUser().realName !== this.state.edit_realName) {
        // 身分証明書の再アップロード処理：まずは現在のデータdelete
        if (users.getMyUser().trustdockId) {
          if (users.getMyUser().trustdockResult) {
            if ("" !== users.getMyUser().trustdockResult) {
              // TRUST DOCKデータ消去
              var options = {
                url: define.TRUSTDOCK_CONFIG.delete_api_url + users.getMyUser().trustdockId,
                method: 'DELETE',
                headers: define.TRUSTDOCK_CONFIG.delete_api_headers
              }

              // Trustdockにデータを送信
              request(options, function (err, res, body) {
                // 完了

              });
            }
          }
        }
        //身分証再アップロード待ち状態※名前を変更した場合は身分証を再登録しなければならない仕様
        statusIdReupload()        

      }
      updateProfile({displayName: this.state.edit_displayName, /*email:this.state.edit_email,*/ bio:this.state.bio, realName: this.state.edit_realName});
      //email変更の場合確認メールを送信する
      if (users.getMyUser().email !== this.state.edit_email) {
        //入力されたメールアドレスがすでに使われていないかチェック
        firebase.database().ref('users').orderByChild('email').equalTo(this.state.edit_email).once('value',(snapshot) => {
          //console.log(snapshot.val())
          if(!snapshot.val()) {
            let tempEmail = this.state.edit_email
            alert('確認メールを送信致しました。')        
            setTempNewEmail(tempEmail)
            this.sendMailForCheckEmail(tempEmail)
          } else {
            alert('入力されたメールアドレスは利用できません。')
          }
        })

      } else {
        browserHistory.push("/user/" + users.getMyUser().uid);
      }
    }

  }

  //email変更の場合確認メールを送信する
  sendMailForCheckEmail = (to) => {
    const localPort = window.location.hostname === 'localhost' ? ':3000' : ''
    let mailSubject = 'MyRate | 登録メールアドレス変更確認メール'
    let createParam = '?m=' + window.btoa(to)
    let mailBody = 'リンクをクリックし登録メールアドレスの変更を完了してください\n' + window.location.protocol + '//' + window.location.hostname + localPort + '/newEdit' + createParam
    let params = {
      'sendToUsers':[to],
      'mailSubject':mailSubject,
      'mailBody':mailBody
    }
    //console.log(params)
    let xhr = new XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if(xhr.readyState === 4) {
        //console.log(xhr.response)
        //alert('確認メールを送信致しました。')
      }
    }

    xhr.open('POST','/api/sendmail')

    xhr.setRequestHeader('Content-Type','application/json')
    //console.log(params)
    xhr.send(JSON.stringify(params))
  }

  // onload
  //componentDidMount() {
  //callbackにmount後でなければならない処理がないのでconstructorでloginチェックとユーザーデータを取得する
  loginCheck = () => {
    //var this = this
    // ログインチェック
    onLogin((isLogin) => {
      if (false === isLogin) {
        //console.log('newedit didmount')
        browserHistory.push("/lpLogin");
        return
      } else {

        this.setState({user:users.getMyUser()})

        this.setState({edit_displayName: htmlspecialchars(users.getMyUser().displayName)})
        this.setState({edit_email: htmlspecialchars(users.getMyUser().email)})
        this.setState({edit_realName: htmlspecialchars(users.getMyUser().realName)})
        let bio = "こんにちは。よろしくお願いします！"
        if ("" !== users.getMyUser().bio && typeof users.getMyUser().bio !== 'undefined') {
          bio = htmlspecialchars(users.getMyUser().bio)
        }
        this.setState({bio: bio})
        this.setState({current_bio_length:bio.length})

        let trustdockId = users.getMyUser().trustdockId
        let trustdockResult = users.getMyUser().trustdockResult
        let trustdockToken = users.getMyUser().trustdockToken


        let error_msg_text = ''
        //身分証登録をスキップしたままのユーザー
        if(!trustdockResult && !trustdockId && !trustdockToken) {
          this.setState({send_trustdock:false})
          error_msg_text = '※身分証の登録が済んでいません。ご登録するまでビギナーランクからランクアップしません。'
        } else {
          //登録済みステータス判定
          //認証失敗時と名前変更時身分証再登録のトーストメッセージを表示する
          this.setState({send_trustdock:true})
          if ("reupload" === trustdockResult || "denied" === trustdockResult) {
            error_msg_text = (<div className="toast-caution"><p>※身分証の認証に失敗しました。</p><p>いただいたお名前と一致する身分証を添付してください。</p></div>)
          }
        }
        this.setState({error_message:error_msg_text})

        //メール変更確認リンクのパラメータをチェックし、tempNewEmailと復号化したパラメータが一致した場合emailを更新する※react-router@v3
        let paramEmail = this.props.location.query.m
        //console.log(window.atob(paramEmail))
        if(paramEmail) {
          getTempNewEmail((val) => {
            if(window.atob(paramEmail) === val) {
              this.props.location.query.m = null
              setTempNewEmail(null)
              const newEmail = window.atob(paramEmail)

              if (!users.getMyUser().facebookId) {
                const { uid, password } = users.getMyUser();
                const decryptedPass = cryptojs.AES.decrypt(password, define.ENV.passwordSecret).toString(cryptojs.enc.Utf8);
                getCurrentEmail(uid)
                  .then(email => {
                    return firebase.auth().signInWithEmailAndPassword(email, decryptedPass)
                  })
                  .then(() => {
                    const user = firebase.auth().currentUser
                    // update auth email
                    return user.updateEmail(newEmail)
                  })
                  .then(() => {
                    users.setCurrentUserEmail(newEmail)
                    // update db email
                    updateEmail(newEmail)
                    alert('登録メールアドレスを更新しました。')
                  })
              } else {
                // update db email
                updateEmail(newEmail)
                alert('登録メールアドレスを更新しました。')
              }

            }
          })

            
        }
      }
    }, false);
  }

  //toastでないエラーメッセージ表示
  showErrorMsg = () => {
    const {
      error_message,
      send_trustdock
    } = this.state

    if (!send_trustdock && error_message) {
      return (
        <div className="wrapCover__contentBlock clearfix error-message">
          <div className="content-top">{error_message}</div>
        </div>
      )
    }
  }  
  //toastメッセージ表示
  returnToast = () => {
    const {
      error_message,
      send_trustdock
    } = this.state
    if(send_trustdock && error_message) {
      return (
        <Toast notifyMessage={error_message} />
      )
    }
  }


  createTrustDockDeleteOptions = (trustdockId) => {
    return {
      url: define.TRUSTDOCK_CONFIG.delete_api_url + trustdockId,
      method: 'DELETE',
      headers: define.TRUSTDOCK_CONFIG.delete_api_headers
    }
  }

  //アカウント削除
  userDelete = (e) => {
    const user = users.getMyUser()
    if ("" !== user.uid) {
      if(window.confirm('この操作は取り消せません。本当にアカウントを削除しますか？\n※アカウント確認のために再認証が必要です。')){

        if (user.facebookId) {
          // ユーザー（FBログイン）削除
          firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
            .then(() => {
              if (user.trustdockId && user.trustdockResult) {
                // TRUST DOCKデータ消去
                const options = this.createTrustDockDeleteOptions(user.trustdockId)
                // TRUSTDOCK 削除リクエスト
                request(options, (err, res, body) => {
                  // 完了
                });
                return
              } else {
                return
              }
            })
            .then(() => {
              // 連携サービスのスコアデータ消去
              return deleteUserScores(user.uid)
            })
            .then(() => {
              const deleteUser = firebase.auth().currentUser;
              //DB削除の前にonLoginの監視をデタッチする
              firebase.database().ref("/users/" + deleteUser.uid).off()
              return deleteUser.delete()
            })
            .then(() => {
              // ユーザーデータ消去
              firebase.database().ref("/users/" + user.uid).set({});
              logout();
              window.location.href = ("/?deleteComplete=true")
              return
          })

        } else {
          // ユーザー削除（Email/Passwordログイン）
          const user = users.getMyUser();
          const decryptedPass = cryptojs.AES.decrypt(user.password, define.ENV.passwordSecret).toString(cryptojs.enc.Utf8);

          firebase.auth().signInWithEmailAndPassword(user.email, decryptedPass)
            .then(() => {
              // TODO: Facebookと同じ処理だから関数化したいところ
              if (user.trustdockId && user.trustdockResult) {
                // TRUST DOCKデータ消去
                const options = this.createTrustDockDeleteOptions(user.trustdockId)
                // TRUSTDOCK 削除リクエスト
                request(options, (err, res, body) => {
                  // 完了
                });
                return
              } else {
                return
              }
            })
            .then(() => {
              // 連携サービスのスコアデータ消去
              return deleteUserScores(user.uid)
            })
            .then(() => {
              const deleteUser = firebase.auth().currentUser;
              //DB削除の前にonLoginの監視をデタッチする
              firebase.database().ref("/users/" + deleteUser.uid).off()
              return deleteUser.delete()
            })
            .then(() => {
              // ユーザーデータ消去
              firebase.database().ref("/users/" + user.uid).set({});
              logout();
              window.location.href = ("/?deleteComplete=true")
              return
          })
        }
      }
    } else {
      console.log("login error");
    }
  }

  componentWillMount () {
    this.setState({user:users.getMyUser()})
  }

  changePhoto = (bool) => {
    this.setState({changephoto:bool})
  }

  showContent = () => {
    const {
      user,
      changephoto,
      send_trustdock
    } = this.state

    if(changephoto) {
      return (
        <Photoupdate user={user} changePhoto={this.changePhoto} />
      )
    } else {

      let btn = []
      if(!send_trustdock || "denied" === user.trustdockResult || "reupload" === user.trustdockResult) {
        btn = (<Link to="/newflow5" className="btn-chan submit">登録する</Link>)
      } else {
        btn = (<Link to="/newflow5" className="btn-chan">登録済み</Link>)
      }
      return (
        <div className="content-top">
          <h1 className="title">アカウント設定</h1>
          <Profileimage user={user} changePhoto={this.changePhoto} />
          <div className="block-basicInfo clearfix">
            <h2 className="subtitle">基本情報</h2>
              <div className="form-group">
                <label>本名</label>
                <input type="text" className="form-control" id="real-name" name="real-name" value={this.state.edit_realName} onChange={this.handleChangeRealName} />
                <label id="warning-text-1">⚠変更後は身分証も更新してください</label>

              </div>
              <div className="form-group">
                <label>ニックネーム（表示名）</label>
                <input type="text" className="form-control" id="name" name="name" value={this.state.edit_displayName} onChange={this.handleChangeName} />
              </div>
              <div className="form-group">
                <label>メールアドレス</label>
                <input type="text" className="form-control" id="email" name="email" value={this.state.edit_email} onChange={this.handleChangeEmail} />
                <label id="warning-text-2">⚠変更後は確認メールをお送りします</label>
              </div>
              <div className="form-group">
                <label>メッセージ</label>
                <textarea className="form-control" rows="5" value={this.state.bio} onChange={this.handleChangeBio}></textarea>
              </div>
              <div>
                { this.showTextLengh() }
                <button className="submit" onClick={this.changeUserInfo}>保存</button>
              </div>
          </div>
          <hr className="border-gray" />

          <div className="block-identification clearfix">
            <h2 className="subtitle">連携情報</h2>
            <table>
            <tbody>
              <tr>
                <th>電話番号</th>
                <td>
                  <Link to="/newflow3" className="btn-chan">登録済み</Link>
                </td>
              </tr>
              <tr>
                <th>身分証明書</th>
                <td>
                  { btn }
                </td>
              </tr>
            </tbody>
            </table>
          </div>

          <Permission permissionState={users.getMyUser().permissions} uid={user.uid}/>
          {/*　ユーザーデータから取得したデータ(users.getMyUser().permissions)を渡す
          且、キーは提携企業テーブルのユニークID
          permissionsがない or users.getMyUser().permissionsに企業データがない（許可/禁止設定されてない）場合（デフォルト）では禁止 */}

          <hr className="border-gray" />
          <Link className="btn-delete" onClick={this.userDelete}>アカウントを削除</Link>
        </div>
      )
    }
  }

  render(){
    return (
    <div id="wrapper">
      { this.returnToast() }
      <div id="" className="wrapper-lp wrapper-accountSetting">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            { this.showErrorMsg() }
            <div className="wrapCover__contentBlock clearfix">
              { this.showContent() }
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  )
}

}


// WEBPACK FOOTER //
// ./src/newEdit.js